import { DefaultPassThrough } from '@primevue/core'
import { InputNumberPassThroughOptions } from 'primevue/inputnumber'
import type { InputNumberDesignTokens } from '@primeuix/themes/types/inputnumber'
import InputStepper from './InputStepper.vue'

export const InputNumberPassthroughConfig: DefaultPassThrough<InputNumberPassThroughOptions> = {
  root: {
    class: 'tw-input-stepper'
  },
  pcInputText: {
    root: {
      class: '!tw-text-sm/[18px]'
    }
  },
  buttonGroup: {
    class: 'tw-input-stepper-button-group'
  }
}

export const InputNumberStyleConfig: InputNumberDesignTokens = {
  button: {
    width: '1.75rem',
    borderColor: 'var(--border-default-color)',
    hoverBorderColor: 'var(--border-hover-color)',
    activeBorderColor: 'var(--border-pressed-color)',
    background: 'var(--color-surface-neutral)', // Currently not supported, overridden in tailwind css
    hoverBackground: 'var(--color-surface-hover)', // Currently not supported, overridden in tailwind css
    activeBackground: 'var(--color-surface-pressed)' // Currently not supported, overridden in tailwind css
  }
}

export default InputStepper
